// extracted by mini-css-extract-plugin
module.exports = {"cards":"styles_cards__1EDLb","emailWrp":"styles_emailWrp__1oMYx","checkboxContainer":"styles_checkboxContainer__2IDBi"};